import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { App } from '../../../App';

import { getGenericTag, getGenericTagRevision } from './redux/generictags.actions';
import { FullGenericTags } from './redux/generictags.selectors';
import { EditGenericTagForm } from './EditGenericTagForm';

import { SmartContainer, Surface } from '../../../styles/Containers';
import { StyledButton } from '../../../styles/matieralui/Button';
import { RevisionSelector } from '../../../components/Publishing/RevisionSelector';
import { FullScreenLoader } from '../../../components/Loaders/FullScreenLoader';
export const PageGenericTagSettings = () => {


    // New Modal
    const dispatch = useDispatch();
    const store = FullGenericTags();
    const { id } = useParams();
    const [activeItem, setActiveItem] = useState(null);
    const [trigger, setTrigger] = useState('resting');

    // Get This Item
    useEffect(() => { dispatch(getGenericTag(id)) }, [id]);

    // Set Active Item
    useEffect(() => {
        if (store?.activeItem) setActiveItem(store.activeItem);
    }, [store.activeItem, store])

    const triggerSave = () => {
        setTrigger('save');
        setTimeout(() => setTrigger('resting'), 2000)
    }

    const renderTopBarChildren = () => {



        return (
            <SmartContainer flex align="center" justify="flex-end">
                <StyledButton variant='contained' onClick={triggerSave}>Save</StyledButton>
            </SmartContainer>
        )

    }

    const handleRevisionChange = (revision) => {

        // Clear Revision
        if (!revision) setActiveItem(store.activeItem);
        else {

            const mergedData = { ...revision.fields, id: revision.modelId }
            setActiveItem(mergedData);
        }
    }

    // Add Revisions
    const sideBarChildren = () => (
        <Surface>
            <RevisionSelector
                label="Revisions"
                item={store?.activeItem}
                model="GenericTag"
                modelId={store?.activeItem?.id}
                selector={FullGenericTags}
                action={getGenericTagRevision}
                onChange={handleRevisionChange}
            />
        </Surface>
    )

    // Render Page
    return (
        <App title="Edit Tag" topBarChildren={renderTopBarChildren()}>
            {store?.activeItemLoading && (<FullScreenLoader />)}
            {!store?.activeItemLoading && (
                <SmartContainer thinking={store?.deleteLoading || store?.updateLoading}>
                    <EditGenericTagForm
                        item={activeItem}
                        childrenSide={sideBarChildren()}
                        trigger={trigger}
                    />
                </SmartContainer>
            )}
        </App>
    )
}